<template>
  <main class="pt-16 bg-gradient-to-b from-gray-300 via-gray-200 to-gray-300 relative min-h-screen flex items-center justify-center">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
      <!-- Message offre terminée -->
      <div class="bg-white rounded-2xl shadow-xl p-8 sm:p-10 md:p-12">
        <div class="text-center">
          <!-- Icône -->
          <div class="mx-auto w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-100 flex items-center justify-center mb-6">
            <svg class="w-10 h-10 sm:w-12 sm:h-12 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>

          <!-- Titre -->
          <h1 class="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            L'offre est terminée
          </h1>

          <!-- Description -->
          <p class="text-gray-600 text-base sm:text-lg leading-relaxed mb-6">
            L'offre de remboursement pour le lancement de la série REDMI Note 15 s'est terminée le <strong class="text-gray-900">15 mars 2026</strong>.
          </p>

          <p class="text-gray-500 text-sm sm:text-base mb-8">
            Merci à tous ceux qui ont participé !
          </p>

          <!-- Bouton retour -->
          <router-link
            to="/"
            class="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 sm:py-4 px-8 sm:px-10 rounded-full transition-all hover:shadow-lg text-sm sm:text-base"
          >
            <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
            </svg>
            <span>Retour à l'accueil</span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Formulaire de participation - DÉSACTIVÉ
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
      <div class="bg-white rounded-lg shadow-lg p-6 sm:p-8">
        <h1 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2 text-center">
          Formulaire de participation
        </h1>
        <p class="text-gray-600 text-center text-sm mb-6">
          Pour participer, veuillez renseigner vos coordonnées :
        </p>

        <Form
          class="w-full mx-auto form-xiaomi"
          id="monform"
          :form_id="form_id"
          :server="server"
          v-on:results="getResult"
          v-on:form_submit_loading="loading"
          @on_error="viewError"
          :hideError="hiderror"
          :relay="relay"
        />

        <div v-if="load" class="flex justify-center items-center py-4">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
        </div>
      </div>
    </div>
    -->

    <!-- Popup de succès - DÉSACTIVÉE
    <transition name="fade-popup">
      <div
        v-if="showSuccessPopup"
        class="fixed inset-0 z-[100] flex items-center justify-center"
      >
        <div class="absolute inset-0 bg-black bg-opacity-60"></div>

        <transition name="popup-scale" appear>
          <div v-if="showSuccessPopup" class="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 text-center">
          <div class="confetti-container">
            <div class="confetti"></div>
            <div class="confetti"></div>
            <div class="confetti"></div>
            <div class="confetti"></div>
            <div class="confetti"></div>
            <div class="confetti"></div>
          </div>

          <div class="mb-6">
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>

          <h2 class="text-2xl font-bold text-gray-900 mb-3">
            Participation enregistrée !
          </h2>
          <p class="text-gray-600 text-sm mb-2">
            Votre demande de remboursement a bien été prise en compte.
          </p>
          <p class="text-gray-500 text-xs mb-6">
            Vous recevrez un email de confirmation avec le lien de suivi de votre participation.
          </p>

            <button
              @click="closePopupAndRedirect"
              class="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg transition-all transform hover:scale-105"
            >
              Retour à l'accueil
            </button>
          </div>
        </transition>
      </div>
    </transition>
    -->
  </main>
</template>

<script>
export default {
  name: "FormView",
  data() {
    return {
      load: false,
      relay: {},
      hiderror: true,
      form_id: "693c206776eeded2e120c13f",
      server: "https://api-gabarit.promo.dev",
      showSuccessPopup: false,
    };
  },
  mounted() {
    sessionStorage.clear();
  },
  methods: {
    loading() {
      this.load = true;
    },
    viewError() {
      this.load = false;
      alert("Une erreur est survenue, veuillez réessayer.");
    },
    getResult(result) {
      setTimeout(() => {
        this.load = false;
        if (result) {
          this.showSuccessPopup = true;
        } else {
          this.openError();
        }
      }, 500);
    },
    openError() {
      this.load = false;
      alert("Une erreur est survenue, veuillez réessayer.");
    },
    closePopupAndRedirect() {
      this.showSuccessPopup = false;
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style>
/* Masquer les étapes */
.form-xiaomi .step {
  display: none;
}

/* Conteneur général du formulaire */
.form-xiaomi .form-step {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Labels */
.form-xiaomi label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}

.form-xiaomi .required-star {
  color: #ef4444;
}

/* Inputs texte, email, tel */
.form-xiaomi input[type="text"],
.form-xiaomi input[type="email"],
.form-xiaomi input[type="tel"] {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-xiaomi input[type="text"]:focus,
.form-xiaomi input[type="email"]:focus,
.form-xiaomi input[type="tel"]:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

/* Form items wrapper - plus compact */
.form-xiaomi .form_item {
  margin-bottom: 8px;
}

.form-xiaomi .input_wrapper_gender,
.form-xiaomi .input_wrapper_user_type,
.form-xiaomi .input_wrapper_address,
.form-xiaomi .input_wrapper_email,
.form-xiaomi .input_wrapper_phone {
  margin-bottom: 4px;
}

/* Nom et Prénom sur la même ligne */
.form-xiaomi .form-step-0 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.form-xiaomi .form-step-0 > div {
  width: 100%;
}

.form-xiaomi .form-step-0 .input_wrapper_last_name,
.form-xiaomi .form-step-0 .input_wrapper_first_name {
  flex: 0 0 calc(50% - 4px); /* 50% moins la moitié du gap (8px/2) */
  width: auto !important;
}

.form-xiaomi .input_wrapper_last_name .form_item,
.form-xiaomi .input_wrapper_first_name .form_item {
  margin-bottom: 0;
}

/* Mobile - empilés */
@media (max-width: 480px) {
  .form-xiaomi .form-step-0 .input_wrapper_last_name,
  .form-xiaomi .form-step-0 .input_wrapper_first_name {
    width: 100% !important;
    flex: 0 0 100%;
  }
}

/* Radio buttons - Statut */
.form-xiaomi .user_type_wrapper #user_type_element {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}

.form-xiaomi .user_type_wrapper #user_type_element label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-weight: 400;
  font-size: 13px;
}

.form-xiaomi .user_type_wrapper #user_type_element input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: #f97316;
  cursor: pointer;
}

/* Radio buttons - Civilité */
.form-xiaomi .boxes {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}

.form-xiaomi .boxes input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: #f97316;
  cursor: pointer;
}

.form-xiaomi .boxes label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-weight: 400;
  font-size: 13px;
  margin-bottom: 0;
}

/* Email et confirmation sur la même ligne */
.form-xiaomi .input_wrapper_email .email_wrapper,
.form-xiaomi .input_wrapper_email .email_confirmation_wrapper {
  display: inline-block;
  width: calc(50% - 6px);
  vertical-align: top;
}

.form-xiaomi .input_wrapper_email .email_wrapper {
  margin-right: 12px;
}

.form-xiaomi .email_confirmation_wrapper {
  margin-top: 0;
}

/* Mobile - empilés */
@media (max-width: 480px) {
  .form-xiaomi .input_wrapper_email .email_wrapper,
  .form-xiaomi .input_wrapper_email .email_confirmation_wrapper {
    display: block;
    width: 100%;
    margin-right: 0;
  }

  .form-xiaomi .email_confirmation_wrapper {
    margin-top: 8px;
  }
}

/* Adresse - lien "Vous ne trouvez pas" */
.form-xiaomi .cannotfind {
  margin-top: 4px;
}

.form-xiaomi .cannotfind a {
  font-size: 12px;
  color: #f97316;
  cursor: pointer;
  text-decoration: underline;
}

.form-xiaomi .cannotfind a:hover {
  color: #ea580c;
}

/* Messages d'erreur */
.form-xiaomi .error {
  color: #ef4444;
  font-size: 12px;
  text-align: left;
  margin-top: 6px;
  line-height: 1.3;
  font-weight: 500;
}

.form-xiaomi .error_container {
  margin-top: 6px;
}

/* Mention champs obligatoires */
.form-xiaomi .mention {
  font-size: 12px;
  color: #6b7280;
  margin-top: 16px;
  margin-bottom: 8px;
}

/* Checkboxes - Opt-in */
.form-xiaomi .opt_in_rules_wrapper,
.form-xiaomi .opt_in_privacy_wrapper,
.form-xiaomi .opt_in_1_wrapper,
.form-xiaomi [class*="opt_in"] .form_item {
  margin-bottom: 12px;
}

.form-xiaomi #opt_in_rules_element,
.form-xiaomi #opt_in_privacy_element,
.form-xiaomi #opt_in_1_element,
.form-xiaomi [id*="opt_in"][id$="_element"] {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.form-xiaomi #opt_in_rules_element label,
.form-xiaomi #opt_in_privacy_element label,
.form-xiaomi #opt_in_1_element label,
.form-xiaomi [id*="opt_in"][id$="_element"] label {
  order: 2;
  font-size: 13px;
  font-weight: 400;
  color: #374151;
  line-height: 1.5;
  margin-bottom: 0;
  cursor: pointer;
}

.form-xiaomi #opt_in_rules_element input[type="checkbox"],
.form-xiaomi #opt_in_privacy_element input[type="checkbox"],
.form-xiaomi #opt_in_1_element input[type="checkbox"],
.form-xiaomi [id*="opt_in"][id$="_element"] input[type="checkbox"] {
  order: 1;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  accent-color: #f97316;
  cursor: pointer;
}

.form-xiaomi [id*="opt_in"][id$="_element"] label a {
  color: #f97316;
  text-decoration: underline;
}

.form-xiaomi [id*="opt_in"][id$="_element"] label a:hover {
  color: #ea580c;
}

/* Texte RGPD */
.form-xiaomi .text-rgpd {
  font-size: 11px;
  text-align: left;
  color: #6b7280;
  line-height: 1.4;
}

.form-xiaomi .text-rgpd a {
  color: #f97316;
  text-decoration: underline;
}

.form-xiaomi .text-rgpd a:hover {
  color: #ea580c;
}

/* Boutons */
.form-xiaomi .builder-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.form-xiaomi button[type="submit"],
.form-xiaomi .suivant {
  background-color: #f97316;
  color: white;
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 15px;
  order: 2;
}

.form-xiaomi button[type="submit"]:hover,
.form-xiaomi .suivant:hover {
  background-color: #ea580c;
}

.form-xiaomi .precedent {
  background-color: #fff;
  color: #374151;
  font-weight: 500;
  padding: 12px 28px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 15px;
  order: 1;
}

.form-xiaomi .precedent:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

/* Captcha caché */
.form-xiaomi .captcha {
  display: none !important;
}

/* Question 48 cachée */
.form-xiaomi .input_wrapper_question_48 {
  display: none !important;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .form-xiaomi .user_type_wrapper #user_type_element,
  .form-xiaomi .boxes {
    flex-direction: column;
    gap: 10px;
  }
}

/* ===== Select dropdown ===== */
.form-xiaomi select {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 20px;
  padding-right: 32px;
}

.form-xiaomi select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

/* ===== Multiselect (vue-multiselect) ===== */
.form-xiaomi .multiselect {
  min-height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-xiaomi .multiselect:focus-within {
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

.form-xiaomi .multiselect__tags {
  min-height: 40px;
  padding: 6px 40px 6px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
}

.form-xiaomi .multiselect__select {
  position: absolute;
  height: 38px;
  width: 40px;
  right: 1px;
  top: 1px;
  padding: 0;
  background: #fff;
  border-radius: 0 5px 5px 0;
  z-index: 1;
}

.form-xiaomi .multiselect__select::before {
  position: relative;
  border-style: solid;
  border-color: #6b7280 transparent transparent;
  border-width: 5px 5px 0;
  content: "";
  top: 65%;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.form-xiaomi .multiselect--active .multiselect__select::before {
  border-color: transparent transparent #f97316;
  border-width: 0 5px 5px;
  top: 50%;
}

/* Hide spinner */
.form-xiaomi .multiselect__spinner {
  display: none !important;
}

.form-xiaomi .multiselect__placeholder {
  color: #9ca3af;
  font-size: 14px;
  padding-top: 2px;
  margin-bottom: 0;
}

.form-xiaomi .multiselect__single {
  font-size: 14px;
  padding: 0;
  margin-bottom: 0;
  background: transparent;
  line-height: 26px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.form-xiaomi .multiselect__input {
  font-size: 14px;
  padding: 0 !important;
  margin-bottom: 0;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  height: auto !important;
}

.form-xiaomi .multiselect__tags-wrap {
  display: none;
}

.form-xiaomi .multiselect__content-wrapper {
  border: 1px solid #d1d5db;
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  background: #fff;
  z-index: 50;
}

.form-xiaomi .multiselect__content {
  padding: 0;
}

.form-xiaomi .multiselect__element {
  margin: 0;
}

.form-xiaomi .multiselect__option {
  padding: 10px 12px;
  font-size: 14px;
  min-height: auto;
  line-height: 1.4;
  white-space: normal;
  color: #374151;
}

.form-xiaomi .multiselect__option--highlight {
  background: #fff7ed;
  color: #374151;
}

.form-xiaomi .multiselect__option--selected {
  background: #f97316;
  color: #fff;
  font-weight: 500;
}

.form-xiaomi .multiselect__option--selected.multiselect__option--highlight {
  background: #ea580c;
  color: #fff;
}

.form-xiaomi .option__desc {
  line-height: 1.4;
}

.form-xiaomi .option__title {
  font-size: 14px;
}

/* Hidden required input for multiselect */
.form-xiaomi .multiselect_hidden {
  opacity: 0 !important;
  pointer-events: none !important;
}

/* ===== File Upload ===== */
.form-xiaomi .upload-btn-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.form-xiaomi .upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  background-color: #f9fafb;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.form-xiaomi .upload-btn:hover {
  border-color: #f97316;
  background-color: #fff7ed;
  color: #f97316;
}

.form-xiaomi .upload-btn-wrapper input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

/* MultipleFiles component */
.form-xiaomi .multiplefiles-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-xiaomi .upload-btn-container {
  position: relative;
}

.form-xiaomi .upload-btn-container input[type="file"],
.form-xiaomi .multiplefiles-container input[type="file"] {
  width: 100%;
  height: 44px;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  color: #6b7280;
}

.form-xiaomi .upload-btn-container input[type="file"]:hover,
.form-xiaomi .multiplefiles-container input[type="file"]:hover {
  border-color: #f97316;
}

.form-xiaomi .upload-btn-container input[type="file"]:focus,
.form-xiaomi .multiplefiles-container input[type="file"]:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

.form-xiaomi .upload-btn-container input[type="file"]::file-selector-button,
.form-xiaomi .multiplefiles-container input[type="file"]::file-selector-button {
  padding: 6px 14px;
  margin-right: 12px;
  border: none;
  border-radius: 4px;
  background-color: #f97316;
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.form-xiaomi .upload-btn-container input[type="file"]::file-selector-button:hover,
.form-xiaomi .multiplefiles-container input[type="file"]::file-selector-button:hover {
  background-color: #ea580c;
}

/* Button + for multiple files */
.form-xiaomi .button_wrapper {
  margin-top: 8px;
}

.form-xiaomi .button_wrapper button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #fff;
  color: #6b7280;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.form-xiaomi .button_wrapper button:hover {
  background-color: #f97316;
  color: #fff;
}

/* Hidden required input for files */
.form-xiaomi .multiplefiles_hidden {
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Info text */
.form-xiaomi .info {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  font-style: italic;
}

/* Warning message */
.form-xiaomi .warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin-top: 8px;
  background-color: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 6px;
  font-size: 13px;
  color: #92400e;
  line-height: 1.4;
}

.form-xiaomi .warning::before {
  content: "⚠️";
  flex-shrink: 0;
}

/* Existing/uploaded files display */
.form-xiaomi .existing-multiplefiles,
.form-xiaomi .existing-file {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-top: 8px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
}

.form-xiaomi .delete-multiplefiles,
.form-xiaomi .delete-file {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 6px;
  background-color: #fee2e2;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.form-xiaomi .delete-multiplefiles:hover,
.form-xiaomi .delete-file:hover {
  background-color: #fecaca;
}

.form-xiaomi .delete-multiplefiles svg,
.form-xiaomi .delete-file svg {
  width: 14px;
  height: 14px;
  fill: #dc2626;
}

.form-xiaomi .link-multiplefiles,
.form-xiaomi .link-file {
  flex: 1;
  min-width: 0;
}

.form-xiaomi .link-multiplefiles a,
.form-xiaomi .link-file a {
  color: #374151;
  text-decoration: none;
  word-break: break-all;
  font-size: 13px;
}

.form-xiaomi .link-multiplefiles a:hover,
.form-xiaomi .link-file a:hover {
  color: #f97316;
  text-decoration: underline;
}

/* File preview (if any) */
.form-xiaomi .file-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-top: 8px;
  background-color: #f3f4f6;
  border-radius: 6px;
  font-size: 13px;
  color: #374151;
}

.form-xiaomi .file-preview .remove-file {
  margin-left: auto;
  color: #ef4444;
  cursor: pointer;
  font-weight: 600;
}

.form-xiaomi .file-preview .remove-file:hover {
  color: #dc2626;
}

/* ===== Popup Animations ===== */

/* Fade transition for popup */
.fade-popup-enter-active,
.fade-popup-leave-active {
  transition: opacity 0.3s ease;
}

.fade-popup-enter,
.fade-popup-leave-to {
  opacity: 0;
}

/* Popup scale animation */
.popup-scale-enter-active {
  animation: popup-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.popup-scale-leave-active {
  animation: popup-out 0.25s ease-in;
}

@keyframes popup-in {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes popup-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
}

/* ===== Success Checkmark Animation ===== */
.success-checkmark {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

.success-checkmark .check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #22c55e;
}

.success-checkmark .check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}

.success-checkmark .check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}

.success-checkmark .check-icon::before,
.success-checkmark .check-icon::after {
  content: '';
  height: 100px;
  position: absolute;
  background: #fff;
  transform: rotate(-45deg);
}

.success-checkmark .check-icon .icon-line {
  height: 5px;
  background-color: #22c55e;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}

.success-checkmark .check-icon .icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}

.success-checkmark .check-icon .icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}

.success-checkmark .check-icon .icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(34, 197, 94, 0.5);
}

.success-checkmark .check-icon .icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #fff;
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 46px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

/* ===== Confetti Animation ===== */
.confetti-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  opacity: 0;
  animation: confetti-fall 3s ease-out forwards;
}

.confetti:nth-child(1) {
  background: #f97316;
  left: 10%;
  animation-delay: 0s;
}

.confetti:nth-child(2) {
  background: #22c55e;
  left: 30%;
  animation-delay: 0.1s;
}

.confetti:nth-child(3) {
  background: #3b82f6;
  left: 50%;
  animation-delay: 0.2s;
}

.confetti:nth-child(4) {
  background: #eab308;
  left: 70%;
  animation-delay: 0.15s;
}

.confetti:nth-child(5) {
  background: #ec4899;
  left: 90%;
  animation-delay: 0.25s;
}

.confetti:nth-child(6) {
  background: #8b5cf6;
  left: 20%;
  animation-delay: 0.05s;
}

@keyframes confetti-fall {
  0% {
    opacity: 1;
    top: -10%;
    transform: rotate(0deg) scale(1);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    top: 100%;
    transform: rotate(720deg) scale(0.5);
  }
}
</style>
